import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BetButtonSelection from './BetButtonSelection';
import { disabledButton } from '~scenes/inplay/components/utils';

const CellSelectionLine = ({
    ids,
    label,
    caption = null,
    isLastRow,
    showSelectionLabels,
    headers = null,
    teamLogo = null,
}) => {

    const betButtons = () => {
        if (headers) {
            return headers.map((header, idx) => {
                if (!ids[header]) {
                    return disabledButton(`${header}-empty-${idx}`);
                }

                return <BetButtonSelection
                    id={ids[header]}
                    key={ids[header]}
                    showSelectionLabels={showSelectionLabels}
                />;
            });
        }

        return ids.map((id, index) => {
            return <BetButtonSelection
                id={id}
                key={`${label}-${id ?? index}`}
                showSelectionLabels={showSelectionLabels}
            />;
        });
    };

    const lineClass = classNames('selections-col-grid__cell', {
        'last-row': isLastRow,
    });

    return (
        <div className={lineClass}>
            {
                teamLogo
                ? <img
                    src={teamLogo}
                    className="cell__body__team-logo"
                />
                : null
            }
            <div className="cell__body">
                {label}
                {
                    caption
                    ? <div className="cell__body__caption">{caption}</div>
                    : null
                }
            </div>
            <div className="selections-col-grid__bet-buttons">
                {betButtons()}
            </div>
        </div>
    );
};

CellSelectionLine.propTypes = {
    ids: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.string.isRequired,
            PropTypes.number.isRequired,
        ])),
    ]),
    label: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    caption: PropTypes.string,
    isLastRow: PropTypes.bool,
    showSelectionLabels: PropTypes.bool,
    headers: PropTypes.arrayOf(PropTypes.string),
    teamLogo: PropTypes.string,
};

export default CellSelectionLine;
